import { render, staticRenderFns } from "./study-label-select.vue?vue&type=template&id=6707474e&scoped=true&"
import script from "./study-label-select.vue?vue&type=script&lang=ts&"
export * from "./study-label-select.vue?vue&type=script&lang=ts&"
import style0 from "./study-label-select.vue?vue&type=style&index=0&id=6707474e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707474e",
  null
  
)

export default component.exports